import Vue from 'vue'
import LightBootstrap from './light-bootstrap-main'
import App from './App.vue'
import axios from './axios'
import Multiselect from 'vue-multiselect'
import './util/filters'
import './csrf-helper'
import './redirect-back'
import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://5ed9ba5fc3ec482887cd541f2bbc9774@o235253.ingest.sentry.io/5473325',
    integrations: [
      new VueIntegration({
        Vue,
        attachProps: true
      })
    ]
  })
}

Vue.prototype.$http = axios

import store from './store'
import router from './router'
import 'es6-promise/auto'

Vue.use(LightBootstrap)
Vue.component('multiselect', Multiselect)

// Global directive to prevent double clicks
Vue.directive('prevent-double-click', {
  inserted(el) {
    el.addEventListener('click', function(e) {
      if (el.disabled) {
        e.preventDefault()
        e.stopPropagation()
        return false
      }

      el.disabled = true
      el.style.opacity = '0.6'
      el.style.cursor = 'not-allowed'

      setTimeout(() => {
        el.disabled = false
        el.style.opacity = ''
        el.style.cursor = ''
      }, 1000) // 1 second delay
    })
  }
})

store.dispatch('authUser').then(() => {
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    render: h => h(App),
    router,
    store
  })
})
